import AdminDashboardTemplate from "Components/templates/admin/dashboard";

const AdminDashboardPage = () => {
    document.title = "Admin Dashboard | IbexIQ";

    return <AdminDashboardTemplate />
}

export default AdminDashboardPage;